'use client'

import CoinLineChart from '@/app/[locale]/price/[slug]/_components/CoinLineChart'

import StockChartInfoTitle from './StockChartInfoTitle'

interface StockLineChartProps {
  customHeader?: React.ReactNode
}

export default function StockLineChart({ customHeader }: StockLineChartProps) {
  return (
    <CoinLineChart
      customHeader={customHeader}
      renderInfoTitle={props => <StockChartInfoTitle {...props} />}
    />
  )
}
